<template>
    <div v-if="!selectTemplate" class="mt-4">

        <el-form-item v-if="showSendEmail" label="Send Email">
            <el-select class="w-100" v-model="emailBuilder.sendEmail" placeholder="Send Email" :disabled="sendEmailDisabled">
                <el-option label="Yes" :value="true"></el-option>
                <el-option label="No" :value="false"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item v-if="showSendSms" label="Send SMS">
            <el-select class="w-100" v-model="emailBuilder.sendSms" placeholder="Send SMS" :disabled="sendSmsDisabled">
                <el-option label="Yes" :value="true"></el-option>
                <el-option label="No" :value="false"></el-option>
            </el-select>
        </el-form-item>

        <el-row v-if="(delayedSending && (emailBuilder.sendEmail || emailBuilder.sendSms))" :gutter="10">
            <el-col :span="emailBuilder.delaySending ? 6 : 24">
                <el-form-item label="Delay Sending">
                    <el-select class="w-100" v-model="emailBuilder.delaySending" placeholder="Delay Sending">
                        <el-option label="Yes" :value="true"></el-option>
                        <el-option label="No" :value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col v-if="emailBuilder.delaySending" :span="18">
                <el-form-item label="Send At">
                    <el-date-picker
                        class="w-100"
                        v-model="emailBuilder.sendAt"
                        type="datetime"
                        placeholder="Select date and time"
                        :picker-options="pickerOptions"
                        :default-time="currentTime">
                    </el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>

    </div>
    <div v-else class="mt-4">
        <el-row v-if="showSendEmail" :gutter="10">
            <el-col :span="emailBuilder.sendEmail ? 6 : 24">
                <el-form-item label="Send Email">
                    <el-select class="w-100" v-model="emailBuilder.sendEmail" placeholder="Send Email" :disabled="sendEmailDisabled">
                        <el-option label="Yes" :value="true"></el-option>
                        <el-option label="No" :value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col v-if="emailBuilder.sendEmail" :span="hasEmailAction ? 9 : 18">
                <el-form-item label="Email Template">
                    <el-select
                        :loading="_.isEmpty(emailTemplates)"
                        clearable
                        placeholder="Select Email Template"
                        style="width: 100%"
                        v-model="templateUid"
                        @change="checkEmailAction">
                        <el-option
                            v-for="emailTemplate in emailTemplates"
                            :key="emailTemplate.uid"
                            :label="emailTemplate.name"
                            :value="emailTemplate.uid"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>

            <el-col v-if="hasEmailAction" :span="9">
                <el-form-item v-if="emailBuilder.emailAction === 'app-form-pack'" label="Select Form">
                    <el-select
                        :loading="_.isEmpty(emailAction.appFormPack.data)"
                        placeholder="Select Form"
                        style="width: 100%"
                        v-model="emailBuilder.emailActionData">
                        <el-option
                            v-for="forms in emailAction.appFormPack.data"
                            :key="forms.slug"
                            :label="forms.name"
                            :value="forms.slug"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        
        </el-row>

        <el-row v-if="showSendSms" :gutter="10">
            <el-col :span="emailBuilder.sendSms ? 6 : 24" :disabled="sendSmsDisabled">
                <el-form-item label="Send SMS">
                    <el-select class="w-100" v-model="emailBuilder.sendSms" placeholder="Send SMS">
                        <el-option label="Yes" :value="true"></el-option>
                        <el-option label="No" :value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>

            <el-col v-if="emailBuilder.sendSms" :span="hasSmsAction ? 9 : 18">
                <el-form-item label="SMS Template">
                    <el-select
                        :loading="_.isEmpty(smsTemplates)"
                        clearable
                        placeholder="Select SMS Template"
                        style="width: 100%"
                        v-model="smsUid"
                        @change="checkSmsAction"
                    >
                        <el-option
                            v-for="smsTemplate in smsTemplates"
                            :key="smsTemplate.uid"
                            :label="smsTemplate.name"
                            :value="smsTemplate.uid"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>

            <el-col v-if="hasSmsAction" :span="9">
                <el-form-item v-if="emailBuilder.smsAction === 'app-form-pack' " label="Select Form">
                    <el-select
                        :loading="_.isEmpty(smsAction.appFormPack.data)"
                        placeholder="Select Form"
                        style="width: 100%"
                        v-model="emailBuilder.smsActionData">
                        <el-option
                            v-for="forms in smsAction.appFormPack.data"
                            :key="forms.slug"
                            :label="forms.name"
                            :value="forms.slug"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row v-if="(delayedSending && (emailBuilder.sendEmail || emailBuilder.sendSms))" :gutter="10">
            <el-col :span="emailBuilder.delaySending ? 6 : 24">
                <el-form-item label="Delay Sending">
                    <el-select class="w-100" v-model="emailBuilder.delaySending" placeholder="Delay Sending">
                        <el-option label="Yes" :value="true"></el-option>
                        <el-option label="No" :value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col v-if="emailBuilder.delaySending" :span="18">
                <el-form-item label="Send At">
                    <el-date-picker
                        class="w-100"
                        v-model="emailBuilder.sendAt"
                        type="datetime"
                        placeholder="Select date and time"
                        :picker-options="pickerOptions"
                        :default-time="currentTime">
                    </el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'EmailSendingOptions',

    props: {
        selectTemplate: {
            required: false,
            type: Boolean,
            default: false
        },
        delayedSending: {
            required: false,
            type: Boolean,
            default: true
        },
        sendEmailDisabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        sendSmsDisabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        showSendEmail: {
            required: false,
            type: Boolean,
            default: true,
        },
        showSendSms: {
            required: false,
            type: Boolean,
            default: true,
        },
        setDefault: {
            required: false,
            type: Boolean,
            default: true,
        }
    },

    computed: {
        ...mapGetters({
            emailBuilder: "builderEmail/getEmail",
            activeEmailTemplates: "builderEmail/getActiveEmailTemplates",
            activeSmsTemplates: "builderEmail/getActiveSmsTemplates",
            templatesLoaded: "builderEmail/checkTemplatesLoaded",
        }),
        emailTemplates() {
            if (!this.activeEmailTemplates) return
            return this.activeEmailTemplates.filter((template) => template.type == "single")
        },
        smsTemplates() {
            if (!this.activeSmsTemplates) return
            return this.activeSmsTemplates.filter((template) => template.type == "single")
        },
        currentTime() {
            return this.$moment().format("HH:mm:ss")
        }
    },

    data() {
        return {
            hasEmailAction: false,
            hasSmsAction: false,
            emailAction: {
                appFormPack: {
                    data: [],
                    loading: true
                }
            },
            smsAction: {
                appFormPack: {
                    data: [],
                    loading: true
                }
            },
            templateUid: "",
            smsUid: "",
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 3600 * 1000 * 24
                },
                shortcuts: [
                    {
                        text: "1 Hour",
                        onClick: (picker) => {
                            let date = this.$moment().add(1, 'hour')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "2 Hours",
                        onClick: (picker) => {
                            let date = this.$moment().add(2, 'hours')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "4 Hours",
                        onClick: (picker) => {
                            let date = this.$moment().add(4, 'hours')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "6 Hours",
                        onClick: (picker) => {
                            let date = this.$moment().add(6, 'hours')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "8 Hours",
                        onClick: (picker) => {
                            let date = this.$moment().add(8, 'hours')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "Tomorrow",
                        onClick: (picker) => {
                            let date = this.$moment().add(1, 'day')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "Next Week",
                        onClick: (picker) => {
                            let date = this.$moment().add(1, 'week')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "Two Weeks",
                        onClick: (picker) => {
                            let date = this.$moment().add(2, 'weeks')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "Next Month",
                        onClick: (picker) => {
                            let date = this.$moment().add(1, 'month')
                            picker.$emit("pick", date)
                        },
                    },
                ],
            },
        }
    },

    methods: {
        checkEmailAction(templateUid) {
            let emailTemplate = this.emailTemplates.find(emailTemplate => emailTemplate.uid === templateUid)
            console.warn("This", this.emailTemplate)
            if (emailTemplate && !_.isNull(_.get(emailTemplate, 'action', null))) {
                this.hasEmailAction = true
                this.emailBuilder.emailAction = emailTemplate.action
                switch (this.emailBuilder.emailAction) {
                    case 'app-form-pack':
                        this.emailAction.appFormPack.loading = true
                        this.$tenant.post("/admin/settings/email-templates/get-app-form-forms")
                            .then(res => {
                                console.warn('res', res)
                                this.emailAction.appFormPack.data = res.data
                                console.warn("This is the result", res)
                            })
                            .catch(err => console.error(err))
                            .finally(() => {
                                this.emailAction.appFormPack.loading = false
                            })
                        break;
                }
            } else {
                this.hasEmailAction = false
                this.emailBuilder.emailAction = null
                this.emailBuilder.emailActionData = null
            }
        },
        checkSmsAction(templateUid) {
            let smsTemplate = this.smsTemplates.find(smsTemplate => smsTemplate.uid === templateUid)
            if (smsTemplate && !_.isNull(_.get(smsTemplate, 'action', null))) {
                this.hasSmsAction = true
                this.emailBuilder.smsAction = smsTemplate.action
                switch (this.emailBuilder.smsAction) {
                    case 'app-form-pack':
                        this.smsAction.appFormPack.loading = true
                        this.$tenant.post("/admin/settings/email-templates/get-app-form-forms")
                            .then(res => {
                                this.smsAction.appFormPack.data = res.data
                            })
                            .catch(err => console.error(err))
                            .finally(() => {
                                this.smsAction.appFormPack.loading = false
                            })
                        break;
                }
            } else {
                this.hasSmsAction = false
                this.emailBuilder.smsAction = null
                this.emailBuilder.smsActionData = null
            }
        }
    },

    mounted() {
        if (this.setDefault) {
            this.emailBuilder.sendEmail = true
            this.emailBuilder.sendSms = false
            this.emailBuilder.delaySending = false
            this.emailBuilder.sendAt = null
        }
    },

    watch: {
        templateUid: {
            handler(templateUid) {
                if (templateUid) {
                    this.$emit('templateUid', templateUid)
                }
            }
        },
        smsUid: {
            handler(smsUid) {
                if (smsUid) {
                    this.$emit('smsUid', smsUid)
                }
            }
        }
    },
};
</script>

<style lang="scss" scoped>

</style>
